<template>
  <div>
      <div style="
          background-color: #4cacff;
          color: #fff;
          position: relative;
          min-height: 40px;
          height: 40px;
          text-align: center;
          line-height: 40px;
      ">
      <span style="font-weight:bold;">Pågående</span>, resultat ej slutgiltigt
      </div>
      <div class="draw-events">
        <div v-for='result in $parent.getForecastObjectEvents' :key='result._id' class="draw-events-flex-parent-container">
          <div class="draw-events-flex-container">
            <div>
              <span class="event-game-title-prefix">{{ result.eventNumber }}</span>
              <span class="event-game-title">{{ result.eventDescription }}</span>
            </div>
            <div>
              <div v-if="result.cancelled" class="game-result-cancelled">Lottad</div>
              <div style="text-align:center" v-else-if="getStartTimeAndDay(result.match.matchStart)">
                  <small>{{ getStartTimeAndDay(result.match.matchStart) }}</small>
              </div>
              <div v-else :class="$parent.styles[result.eventNumber] ? 'blink_me game-result-score' : 'game-result-score'" style="position:relative;">

                <div style="
                position: absolute;
                text-align: right;
                margin-left: -55px;
                width: 50px;">
                    <MatchTimer :match="result.match" :statuses="statuses" />
                </div>

                  <span :style="$parent.styles[result.eventNumber] ? $parent.styles[result.eventNumber].home : ''">
                    {{ result.home || result.match.result[0].home }}
                  </span>
                   -
                  <span :style="$parent.styles[result.eventNumber] ? $parent.styles[result.eventNumber].away : ''">
                    {{ result.away || result.match.result[0].away }}
                  </span>

              </div>
            </div>
            <div>
              <div v-if="!getStartTimeAndDay(result.match.matchStart)">{{result.outcome}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="turnover-container">
        Omsättning: {{ $parent.getDrawTurnover }} kr
      </div>

      <div style="
          background-color: #4cacff;
          color: #fff;
          position: relative;
          min-height: 40px;
          height: 40px;
          text-align: center;
          line-height: 40px;
      ">
      <span style="font-weight:bold;">Utdelning</span>, ej slutgiltigt
      </div>

      <div class="winner-container" v-if="$parent.getMultiForecast">
        <div class="forecast-payment-container">
          <div>
          </div>
          <div>
            <span class="forecast-outcome">1</span>
          </div>
          <div>
            <span class="forecast-outcome">X</span>
          </div>
          <div>
            <span class="forecast-outcome">2</span>
          </div>
        </div>
        <div class="forecast-payment-container" v-for='group in $parent.getMultiForecast' :key='group._id'>
          <div>
            {{ translate(group[0].winDiv) }} rätt
          </div>
          <div v-for='winGroup in group' :key='winGroup._id' class="forecast-payment-container">
            {{ $parent.renderStyledAmount(winGroup.winValue) }} kr
          </div>
        </div>
      </div>

      <div class="winner-container" v-if="!$parent.getMultiForecast">
        <div class="forecast-payment-container" v-for='result in $parent.getForecastWinresult' :key='result._id'>
          <div>
          {{ translate(result.winDiv) }} rätt
          </div>
          <div>
          {{ result.winners }} st
          </div>
          <div>
          {{ $parent.renderStyledAmount(result.winValue) }} kr
          </div>
        </div>
      </div>

    </div>
</template>

<script>
//import _ from 'lodash';
import moment from 'moment';
import MatchTimer from './matchTimer';

export default {
  components: {
    MatchTimer
  },
  data: () => ({
    name: 'DrawClosed',
    statuses: {
      NOT_STARTED: 0,
      FIRST_PERIOD: 1,
      SECOND_PERIOD: 2,
      THIRD_PERIOD: 3,
      FOURTH_PERIOD: 4,
      FIFTH_PERIOD: 5,
      FIRST_HALF: 6,
      SECOND_HALF: 7,
      FIRST_SET: 8,
      SECOND_SET: 9,
      THIRD_SET: 10,
      FOURTH_SET: 11,
      FIFTH_SET: 12,
      STARTED: 13,
      PAUSE: 14,
      HALF_TIME: 15,
      AWAITING_EXTRA_TIME: 16,
      EXTRA_TIME_HALF_TIME: 17,
      AWAITING_PENALTIES: 18,
      IN_OVERTIME: 19,
      IN_FIRST_EXTRA_PERIOD: 20,
      IN_SECOND_EXTRA_PERIOD: 21,
      IN_PENALTIES: 22,
      POSTPONED: 23,
      START_DELAYED: 24,
      CANCELLED: 25,
      INTERRUPTED: 26,
      SUSPENDED: 27,
      ABANDONED: 28,
      WALKOVER: 29,
      PARTICIPANT_RETIRED: 30,
      ENDED: 31,
      ENDED_AFTER_EXTRA_TIME: 32,
      ENDED_AFTER_PENALTIES: 33,
      IN_FIRST_BREAK: 34,
      IN_SECOND_BREAK: 35,
      IN_THIRD_BREAK: 36,
      FIRST_QUARTER: 37,
      SECOND_QUARTER: 38,
      THIRD_QUARTER: 39,
      FOURTH_QUARTER: 40,
      FINISHED: 41
    }
  }),
  methods: {
    getCurrentMatchTimer(match){
      if (match.statusId == this.statuses.FINISHED)
        return null;

      var minuteOffset = moment(new Date()).diff(moment(match.statusTime), 'minutes');
      if (match.statusId == this.statuses.SECOND_HALF)
        minuteOffset = minuteOffset + 45;
      return minuteOffset + "'";
    },
    getStartTimeAndDay(date) {
      var days = ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'];
      var d = new Date(Date.parse(date));
      var dayName = days[d.getDay()];

      var h = d.getHours();
      var m = d.getMinutes();
      m = (m < 10) ? "0" + m : m;

      // Kolla om tiden är paserad
      if (d < new Date())
        return null;

      return dayName + ' ' + h + ':' + m
    },
    getMatchStatusText(statusId) {
      switch (statusId) {
        case this.statuses.HALF_TIME:
          return 'HT';
        case this.statuses.FIRST_HALF:
          return '0+'
        case this.statuses.SECOND_HALF:
          return '45+'
        case this.statuses.IN_OVERTIME:
        case this.statuses.AWAITING_EXTRA_TIME:
        case this.statuses.EXTRA_TIME_HALF_TIME:
        case this.statuses.ENDED_AFTER_EXTRA_TIME:
        case this.statuses.AWAITING_PENALTIES:
          return 'ÖT';
        case this.statuses.IN_PENALTIES:
          return 'STR';
        case this.statuses.ENDED_AFTER_PENALTIES:
          return 'STR';

        case this.statuses.FIRST_PERIOD:
          return '1:a';
        case this.statuses.SECOND_PERIOD:
          return '2:a';
        case this.statuses.THIRD_PERIOD:
          return '3:e';
        case this.statuses.FOURTH_PERIOD:
          return '4:e';
        case this.statuses.FIFTH_PERIOD:
          return '5:e';
        case this.statuses.PAUSE:
          return 'Paus';

        case this.statuses.ENDED:
        case this.statuses.FINISHED:
          return 'FT';
        default:
          return null;
      }
    },
    translate(id) {
      let winners = 13;
      switch (id) {
        case 1:
          winners = '13';
          break;
        case 2:
          winners = '12';
          break;
        case 3:
          winners = '11';
          break;
        case 4:
          winners = '10';
          break;
        default:
      }
      return winners;
    }
  }
};
</script>

<style>
.forecast-payment-container {
  display: flex;
  flex-wrap: nowrap;
  font-size:11px;
}
.forecast-payment-container > div:first-child {
  min-width:50px;
}
.forecast-payment-container > div:nth-child(2) {
  white-space:nowrap;
  margin-left:auto;
}
.forecast-payment-container > div:nth-child(3) {
  white-space:nowrap;
  margin-left:auto;
}
.forecast-payment-container > div:last-child {
  white-space:nowrap;
  margin-left:auto;
}
.forecast-outcome{
  font-weight:bold;
  font-size:14px;
}
.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
